import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ImagePaths } from "utils/ImagePath";
import SuccessGif from "assets/animation/Success.gif";

const PasswordSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user_name } = location.state || {};

  return (
    <div className="h-screen flex items-center justify-center relative bg-gray-50 font-sans">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')]
        bg-cover bg-center opacity-10"
      ></div>
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>

      {/* Card */}
      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={ImagePaths.loginLogo.default}
            alt="App Logo"
            className="h-10 w-auto animate-fadeIn"
          />
        </div>

        <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-xl p-6 text-center animate-fadeIn">
          {/* Success Icon / Animation */}
          <img
            src={SuccessGif}
            alt="Success"
            className="w-24 h-24 mx-auto mb-4"
          />

          {/* Heading */}
          <p className="text-lg font-semibold text-gray-800 mb-2">
            🎉 Congratulations {user_name || "User"}!
          </p>

          {/* Subtext */}
          <p className="text-sm text-gray-600 mb-6">
            Your password has been changed successfully.
          </p>

          {/* Button */}
          <button
            onClick={() => navigate("/")}
            className="w-full py-2 px-4 rounded-lg text-white font-semibold bg-[#04b7b1] hover:bg-[#04b7b1]/80 focus:ring-2 focus:ring-[#04b7b1] focus:ring-offset-2 transition"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordSuccess;
